export const useSearch = (term: string) => {
  if (!window.gtag) return;

  window.gtag('event', 'search', {
    search_term: term,
  });
};
